import React from 'react';
import { Formik, Form } from 'formik';

import {
  showFieldIf,
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import SrFormikField, {
  SR_FIELD_THEME_PARTNER_FORM_ADOBE,
  SR_FIELD_THEME_FORM_INPUT_BORDER_2X,
} from 'client/components/SrFormikField';
import SrBox from 'client/components/SrBox';
import SrTextGreycliff from 'client/components/SrTextGreycliff';
import SrPartnerListingWithdrawModal from 'client/components/SrPartnerListingWithdrawCard/SrPartnerListingWithdrawModal';

const getFormFields = ({ formValues = {} } = {}) => {
  const formFields = [
    {
      id: 'withdrawalDateOption',
      type: 'select',
      properties: {
        placeholder: 'Select option',
        enableResetOption: true,
        choices: [
          {
            label: 'Within 48 hours',
            value: 'next48Hours',
          },
          {
            label: 'Future date',
            value: 'futureDate',
          },
        ],
      },
      validations: ['required'],
    },
    showFieldIf(formValues.withdrawalDateOption === 'futureDate', {
      id: 'withdrawalDate',
      properties: {
        placeholder: 'Select date',
        className: `${SR_FIELD_THEME_FORM_INPUT_BORDER_2X} uninstallOrderDatePicker`,
      },
      type: 'date_picker',
      validations: ['required'],
    }),
  ];

  return formFields;
};

const SrPartnerListingWithdrawDateModal = ({ onClose, onSubmit }) => {
  return (
    <Formik
      initialValues={createInitialValues({
        formFields: getFormFields(),
        defaultValues: {
          withdrawalReasonn: 'Leased',
        },
      })}
      validate={(formValues) => {
        const formFields = getFormFields({ formValues });
        return createFormValidationFn(formFields)(formValues);
      }}
      onSubmit={(formValues) => {
        const moveInDate = formValues.withdrawalDate || new Date().toISOString();
        onSubmit({ moveInDate });
      }}
      render={(formikBag) => {
        const formFields = getFormFields({ formValues: formikBag.values });
        return (
          <SrPartnerListingWithdrawModal
            disabled={!formikBag.isValid}
            confirmText="Order Withdrawal"
            onClose={onClose}
            onConfirm={formikBag.handleSubmit}
          >
            <Form>
              <SrBox textAlign="center" margin="0 0 20px">
                <img
                  width="130px"
                  height="auto"
                  src="/images/install-marketing-items-car.svg"
                  alt="uninstall"
                />
                <SrBox height="16px" />
                <SrTextGreycliff weight="800" size="26" lineHeight="33px" display="block">
                  When should Sunroom withdraw the home?
                </SrTextGreycliff>
              </SrBox>
              <SrBox marginTop="10px">
                {formFields.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                    theme={SR_FIELD_THEME_PARTNER_FORM_ADOBE}
                  />
                ))}
              </SrBox>
            </Form>
          </SrPartnerListingWithdrawModal>
        );
      }}
    />
  );
};

SrPartnerListingWithdrawDateModal.displayName = 'SrPartnerListingWithdrawDateModal';

export default SrPartnerListingWithdrawDateModal;
